/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react'
import SidePopup from '../../../../components/SidePopup';
import extractMonthYearInRange from '../../../../CommonMethods/extractMonthYearInRange';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import Loader from '../../../../components/Loader';
import GlobalContext from '../../../../components/Context/GloablContext';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import S3UploadHook from '../../../../CommonMethods/S3UploadHook';
import Toast from '../../../../components/Toast';
import { dataService } from '../../../../services/data.services';
import FailedPopup from './FailedPopup';
import AlreadyExists from './ AlreadyExists';
import AnimatedModel from '../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt';

export default function SidePopupBar({
    handleSidePopupClick,
    setIsSidePopup,
    getPayrollUsers
}) {
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {setToastmessage} = useContext(GlobalContext);
    const [actionErrorMessage, setActionErrorMessage] = useState("");
    const [dropdownValue, setDropDownValue] = useState({})
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [monthDorpDown, setMonthDropDown] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState("")
    const [buttonLoading, setButtonLoading] = useState(false)
    const [note, setNote] = useState("")
    const [progressCount, setprogressCount] = useState(0)
    const [s3Key, setS3Key] = useState("")
    const [monthError, setMonthError] = useState(false)
    const [selectedError, setSelectedError] = useState(false)
    const [failureData, setFailureData] = useState({})
    const [alreadyExit, setAlreadyExit] = useState(false)
    const [openStatus, setOpenStatus] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [focusedIndex, setFocusedIndex] = useState(-1);
    
    const wrapperRef = useRef();
    const listRef = useRef();
    const buttonRef = useRef(null);
    const optionsRef = useRef([]);


    useEffect(() => {
        const array = extractMonthYearInRange(JSON.parse(localStorage.getItem('FY_details')).start_date, JSON.parse(localStorage.getItem('FY_details')).end_date)
        setMonthDropDown(array)

        const currentMonthYear = new Date().toLocaleDateString('default', { month: 'short', year: 'numeric' });
        const currentIndex = array.findIndex(monthYear => monthYear === currentMonthYear);
        if (currentIndex !== -1) {
            setSelectedMonth(currentMonthYear);
        } else {
            setSelectedMonth(array[0]);
        }


    },[])

    /**
     * The handleDropdownToggle function toggles the state of the dropDownOpen variable.
     */
    const handleDropdownToggle = () => {
        const isOpening = !dropDownOpen;
        setDropDownOpen(isOpening);
        if (isOpening) {
            setTimeout(() => listRef.current?.focus(), 0);
        }
    }

    /* The above code is defining a function called `useOnClickOutside` that takes two parameters:
    `dropdownRef` and an arrow function. Inside the function, it is calling `setDropDownOpen(false)`
    to set the `dropDownOpen` state to `false`. This function is likely used to handle a click event
    that occurs outside of a specific dropdown element. */
    useOnClickOutside(wrapperRef,()=>{
        setDropDownOpen(false)
        setFocusedIndex(-1);
    })

    useEffect(() => {
        if (dropDownOpen && focusedIndex !== -1 && optionsRef.current[focusedIndex]) {
            optionsRef.current[focusedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    }, [focusedIndex, dropDownOpen]);

    const handleKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === 'Return') && !dropDownOpen) {
            e.preventDefault();
            setDropDownOpen(true);
            setTimeout(() => listRef.current?.focus(), 0);
        } else if (e.key === 'Escape' || e.key === 'Tab') {
            setDropDownOpen(false);
            setFocusedIndex(-1);
        }
    };

    const handleListKeyDown = (e) => {
        e.stopPropagation();
        if (e.key === 'Escape' || e.key === 'Tab') {
            setDropDownOpen(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
            return;
        }
    
        if (monthDorpDown.length > 0) {
            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    (prevIndex < monthDorpDown.length - 1 ? prevIndex + 1 : 0)
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    (prevIndex > 0 ? prevIndex - 1 : monthDorpDown.length - 1)
                );
                break;
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (focusedIndex !== -1) {
                    handleChangeOnGoingFY(monthDorpDown[focusedIndex]);
                } else {
                    setDropDownOpen(false);
                    setFocusedIndex(-1);
                    buttonRef.current.focus();
                }
                break;
            default:
                break;
            }
        } else if (e.key === 'Enter' || e.key === 'Return') {
            e.preventDefault();
            setDropDownOpen(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
        }
    };

    const handleChangeOnGoingFY = (item) => {
        if(selectedMonth !== item) {
            setS3Key("")
        }
        setSelectedMonth(item)
        setToastErrorMessage("")
        setSelectedError(false)
        setMonthError(false)
        setDropDownOpen(false);
        setFocusedIndex(-1);
    }

    /**
     * The function `handleDownloadSampleFile` is used to download a sample file and display a toast
     * message indicating the success or failure of the download.
     */
    const handleDownloadSampleFile = () => {
        try {
            window.open(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.ap-south-1.amazonaws.com/public/payroll/sample_file_download/sample_payroll_upload.xlsx`, '_blank');
            // getStudentsDirectory()
            setToastmessage("Sample file downloaded successfully");
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
        
    }

    /**
     * The function `handleImportFile` handles the uploading of a file, checks if a month is selected
     * before uploading, and sets the S3 key for the uploaded file.
     * @returns The function does not have a return statement, so it does not explicitly return
     * anything.
     */
    async function handleImportFile(e) {
        if(e.target.files !== undefined) {
            setMonthError(false)
            if(selectedMonth === "") {
                setToastErrorMessage("Please select a month before uploading the file")
                e.target.value = null;
                setMonthError(true)
                return
            } else {
                let file = e.target.files[0];
                let url = ''
                if (file.name && file.type) {
                    const branch_id = await GetBranchId()
                    url = await S3UploadHook(file, `payroll/${branch_id}/${JSON.parse(localStorage.getItem('FY_details')).name}/${selectedMonth}/${file.name}`, setprogressCount, true);
                    setS3Key(url)
                }
                e.target.value = null;
            }
        }
        
    }

    /**
     * The function `handleUpload` is an asynchronous function that handles the upload of a file in a
     * React application, performing various checks and displaying error messages or success messages
     * based on the response from the server.
     * @returns The function `handleUpload` does not have a return statement, so it does not explicitly
     * return anything.
     */
    const handleUpload = async() => {
        setSelectedError(false);
        setToastErrorMessage("");
        if(selectedMonth === "" || s3Key === "") {
            setButtonLoading(false)
            setSelectedError(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            return
        }
        if(openStatus) {
            setIsSidePopup(true)
            setActivateButtonLoading(true)
        } else{
            setButtonLoading(true)
        }
        if(JSON.parse(localStorage.getItem('FY_details')).status === "open" && !openStatus) {
            setButtonLoading(false)
            setActivateButtonLoading(false)
            setOpenStatus(true)
            return
        } 
      

        try {
            const body = {
                "note": note,
                "s3_key": s3Key
            }
            const importresponse = await dataService.PostAPI(body, `payroll/upload`)
            if(importresponse?.data?.data?.failures?.length === 0) {
                setOpenStatus(false)
                setToastmessage(importresponse?.data?.data?.message)
                getPayrollUsers()
                handleSidePopupClick()
            }
            setFailureData(importresponse?.data?.data)
        } catch (error) {
            setOpenStatus(false)
            setFailureData(error?.response?.data)
            if(error?.response?.data?.message === "Payroll data already exists. Please delete it and try again.") {
                setAlreadyExit(true);
            } else {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
        }
        setActivateButtonLoading(false)
        setButtonLoading(false)
    }
    return (
        <>
            <SidePopup
                addOpen={true}
                class="bg-''"
                componentName={`Upload Payroll`}
                handleSidePopupClick={handleSidePopupClick}
                actionErrorMessage={actionErrorMessage}
                setActionErrorMessage={setActionErrorMessage}
                popUp={openStatus}
                element={
                    <>
                        {(failureData?.failures?.length === 0  || failureData?.failures === undefined && !alreadyExit)? 
                            <>
                                <div className='px-6 pt-[22px]'>
                                    <div className='flex items-center mb-4'>
                                        <p className='text-f7 font-normal min-w-[110px]'>Financial Year</p>
                                        <div className='relative ml-3 w-[200px]' >
                                            <p 
                                                className='text-start text-f7 font-semibold text-[#031624] more-lines'
                                                title={`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}
                                            >{`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}</p>
                                        </div>
                                    </div>
                                    <div className=' flex items-center border-[D0D5DD] mb-4'>
                                        <p className='text-f7 font-normal min-w-[110px]'>Month</p>
                                        <div className='relative ml-3 w-[200px]' ref={wrapperRef}>
                                            <button 
                                                id='month'
                                                ref={buttonRef}
                                                disabled={dropdownValue?.length === 0}
                                                className={`${monthError || (selectedError && selectedMonth === "") ? "redBorder" : ""} slct-inpt-fld`} 
                                                onClick={handleDropdownToggle}
                                                onKeyDown={handleKeyDown}>
                                                <p 
                                                    className={`text-start text-f7 font-normal ${selectedMonth === "" ? "text-[#818E98]" : "text-[#031624]"} more-lines`}
                                                    title={selectedMonth}
                                                >{selectedMonth === "" ? "Select Month" : selectedMonth}</p>
                                                <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${dropDownOpen ? "transform rotate-180" : ""}`}/>
                                            </button>
                                            {dropDownOpen &&
                                            <ul 
                                                ref={listRef}
                                                className='slct_drp_dwn min-w-full max-h-[145px] overflow-auto z-10 scroll-bar'
                                                tabIndex="-1" 
                                                onKeyDown={handleListKeyDown}
                                                style={{outline: 'none'}}
                                            >
                                                {
                                                    (monthDorpDown.map((item, i) => (
                                                        <li 
                                                            key={item} 
                                                            ref={el => optionsRef.current[i] = el}
                                                            className={`${focusedIndex === i ? 'bg-gray-100' : ''}`}
                                                        >
                                                            <div
                                                                onClick={() =>  handleChangeOnGoingFY(item)}
                                                                className='slct_drp_dwn_optn'
                                                                style={{ display: 'flex', alignItems: 'center' }}>
                                                                {item === selectedMonth
                                                                    ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                                                    : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                                                }
                                                                <span>{item}</span>
                                                            </div>
                                                        </li>
                                                    )))
                                                }
                                            </ul>
                    
                                            }
                                        </div>
                                    </div>
                                    <div className=' flex items-center mb-4'>
                                        <p className='text-f7 font-normal min-w-[110px]'>Notes</p>
                                        <div className='h-[50px] ml-3 w-[200px]'>
                                            <textarea
                                                className="txt-fld w-full"
                                                placeholder="Enter Notes"
                                                autoComplete='off'
                                                value={note}
                                                onChange={(e) => {setNote(e.target.value)}}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className='pb-5 border-b border-[#E6E8EA] mt-8'>
                                        <div className='flex justify-between'>
                                            <p className='text-[#031624] font-normal text-f7'>
                                                &nbsp;
                                            </p>
                                            <p 
                                                onClick={() => {handleDownloadSampleFile()}}
                                                className='text-[#106EB4] font-normal text-f7 cursor-pointer'
                                            >
                                                Download Sample File
                                            </p>
                                        </div>
                                        <div className={`relative border ${selectedError && s3Key === "" ?  "border-[#F04438]"  : "border-[#4D555B]"} border-dashed py-5`}>
                                            <img src='/images/file-blue.svg' onClick={(e) => handleImportFile(e)} className='w-[18px] mx-auto cursor-pointer'/>
                                            <div className='relative mx-auto w-fit flex'>
                                                <label htmlFor="upload_file " className='text-f7 font-normal text-[#031624] flex items-center'>
                                                    <p className='more-lines break-all' >
                                                        {s3Key === "" ? "Click to Select File" : s3Key.split("/")[s3Key.split("/")?.length - 1]}
                                                    </p>
                                        
                                                </label>
                                                
                                                <input 
                                                    title={s3Key.split("/")[s3Key.split("/")?.length - 1]}
                                                    type={s3Key === "" ? "file" : "text"}
                                                    id="upload_file"
                                                    onChange={(e) => handleImportFile(e)}
                                                    accept=".xlsx, .xls"
                                                    disabled={s3Key !== ""}
                                                    data-allowed-file-extensions=".xlsx,.xls"
                                                    className='opacity-0 absolute top-0 left-0 w-[50px]'
                                                />
                                                <div>
                                                    {s3Key !== "" && <span>
                                                        <img 
                                                            loading="lazy" 
                                                            decoding="async" 
                                                            src="/images/file-remove.svg" 
                                                            alt="icon" 
                                                            className="w-5 h-5 ml-1 cursor-pointer mt-0.5" 
                                                            onClick={() => {setS3Key("")}}
                                                        />
                                                    </span>}
                                                </div>
                                            </div>
                                            <p className='text-[#344054] text-xs font-normal text-center'>Supported file type: xlsx</p>
                                        </div>
                                    </div>
                                    <div class=" flex -mx-2.5 mt-5">
                                        <div class="w-1/2">
                                            <div class="w-full flex justify-end">
                                                <button 
                                                    onClick={() => {handleSidePopupClick(); getPayrollUsers()}}
                                                    type="button" 
                                                    id='Cancel'
                                                    class="cancl-btn" data-te-modal-dismiss="" aria-label="Close">Cancel</button>
                                            </div>
                                        </div>
                                        <div class="w-1/2">
                                            <div class="w-full">
                                                <button 
                                                    type="button" 
                                                    id="upload" 
                                                    onClick={() => handleUpload()}
                                                    class="actn-btn onboardInstitution" 
                                                    tabindex="0"
                                                >{buttonLoading ? <Loader /> : "Upload"}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {toastErrorMessage!=='' &&<Toast
                                    message={toastErrorMessage}
                                    type="error"
                                    setToastmessage={setToastErrorMessage} />}
                            </>
                            :
                            <>
                                {
                                    alreadyExit ?
                                        <AlreadyExists 
                                            handleSidePopupClick={handleSidePopupClick}
                                            setAlreadyExit={setAlreadyExit}
                                            selectedMonth={selectedMonth}
                                        />
                                        :
                                        <FailedPopup 
                                            handleSidePopupClick={handleSidePopupClick}
                                            setFailureData={setFailureData}
                                            failureData={failureData}
                                            getPayrollUsers={getPayrollUsers}
                                        />
                                }
                        
                            </>
                        }
                    
                    </>
                }
            
            />
            {openStatus && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleUpload}
                        handleClose={() => setOpenStatus(false)}
                        crossMark
                        additionalMessage={`Payroll is being uploaded for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        tittle={'Back Dated Entry'}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
    )
}
